import React from 'react';

const About = () => {
  const features = [
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
        </svg>
      ),
      title: 'Professionnalisme garanti',
      description: 'Des techniciens certifiés et expérimentés'
    },
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      title: 'Rapidité d\'intervention',
      description: 'Disponibles 7j/7 pour vos urgences'
    },
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      title: 'Tarifs transparents',
      description: 'Devis gratuit et sans engagement'
    }
  ];

  const commitments = [
    { number: 1, text: 'Respect des délais convenus' },
    { number: 2, text: 'Qualité de service irréprochable' },
    { number: 3, text: 'Écoute et conseil personnalisé' },
    { number: 4, text: 'Satisfaction client garantie' }
  ];

  return (
    <section id="apropos" className="py-24 bg-gradient-to-br from-blue-900 to-blue-800 text-white relative overflow-hidden">
      <div className="deco-circle w-96 h-96 -bottom-48 -left-48"></div>
      <div className="deco-square w-40 h-40 top-20 right-20"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Pourquoi choisir <span className="gradient-text bg-gradient-to-r from-orange-400 to-yellow-300">CG SERVICE</span> ?
            </h2>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Depuis plus de 15 ans, nous accompagnons particuliers et professionnels dans tous leurs projets. Notre équipe de techniciens qualifiés met son expertise à votre service pour des interventions rapides et de qualité.
            </p>
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                    {feature.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-1">{feature.title}</h3>
                    <p className="text-gray-300">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold mb-6">Nos engagements</h3>
              <div className="space-y-6">
                {commitments.map((commitment, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-yellow-400 rounded-2xl flex items-center justify-center text-2xl font-bold mr-4">
                      {commitment.number}
                    </div>
                    <p className="text-lg">{commitment.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
